import { render, staticRenderFns } from "./topList.vue?vue&type=template&id=413b8c52&scoped=true"
import script from "./topList.vue?vue&type=script&lang=js"
export * from "./topList.vue?vue&type=script&lang=js"
import style0 from "./topList.vue?vue&type=style&index=0&id=413b8c52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413b8c52",
  null
  
)

export default component.exports